import { create } from "zustand"

// Which quotation's on-demand Quotation Details Word file is being generated right now (#1448), or
// null. Module-level for the same reason as resultCsv.store.ts: the editor's burger menu re-roots
// whenever Apryse re-renders the header, so local component state would lose the busy flag
// mid-generation. Kept separate from resultCsv.store's busy flag — a CSV and a Word-file build are
// independent backend jobs, so there is no reason to block one while the other runs.
type DetailsWordStore = {
	busyQuotationId: number | null
	setBusyQuotationId: (quotationId: number | null) => void
}

export const useDetailsWordStore = create<DetailsWordStore>((set) => ({
	busyQuotationId: null,
	setBusyQuotationId: (quotationId) => set({ busyQuotationId: quotationId }),
}))

export const useIsDetailsWordPending = () => useDetailsWordStore((state) => state.busyQuotationId !== null)

// Selector for the quotations table's row menu, mirroring resultCsv.store's own: only the row that is
// generating relabels its item, so the menu needs the id, not just the boolean.
export const useDetailsWordBusyQuotationId = () => useDetailsWordStore((state) => state.busyQuotationId)
